<app-nav-bar></app-nav-bar>
<div class="contact-container">
    <!-- Page Header -->
    <div class="contact-header">
        <div class="header-content">
            <h1 class="contact-title">
                <fa-icon class="title-icon" [icon]="['fas', 'phone']"></fa-icon>
                Contact Information
            </h1>
            <p class="contact-subtitle">Get in touch with our team for support, sales, or other inquiries</p>
        </div>
    </div>

    <!-- Contact Cards Grid -->
    <div class="contact-cards-grid">
        <!-- Address Card -->
        <div class="contact-card">
            <div class="card-header">
                <div class="card-icon address-icon">
                    <fa-icon [icon]="['fas', 'map-marker-alt']"></fa-icon>
                </div>
                <div class="card-title-section">
                    <h2 class="card-title">Address</h2>
                    <p class="card-description">Mailing address</p>
                </div>
            </div>
            <div class="card-body">
                <div class="contact-item">
                    <p class="contact-text">391 South 430 East</p>
                    <p class="contact-text">Lehi, UT 84043</p>
                    <p class="contact-text secondary">USA</p>
                </div>
            </div>
        </div>

        <!-- Development Card -->
        <div class="contact-card">
            <div class="card-header">
                <div class="card-icon dev-icon">
                    <fa-icon [icon]="['fas', 'code']"></fa-icon>
                </div>
                <div class="card-title-section">
                    <h2 class="card-title">Development</h2>
                    <p class="card-description">Technical support & inquiries</p>
                </div>
            </div>
            <div class="card-body">
                <div class="contact-item">
                    <a href="tel:+13852019261" class="contact-link">
                        <fa-icon [icon]="['fas', 'phone']"></fa-icon>
                        (385) 201-9261
                    </a>
                </div>
            </div>
        </div>

        <!-- Sales Card -->
        <div class="contact-card">
            <div class="card-header">
                <div class="card-icon sales-icon">
                    <fa-icon [icon]="['fas', 'handshake']"></fa-icon>
                </div>
                <div class="card-title-section">
                    <h2 class="card-title">Sales</h2>
                    <p class="card-description">Questions about our services</p>
                </div>
            </div>
            <div class="card-body">
                <div class="contact-item">
                    <a href="tel:+18013692561" class="contact-link">
                        <fa-icon [icon]="['fas', 'phone']"></fa-icon>
                        (801) 369-2561
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>